let ip = window.location.hostname;

module.exports = {
  BASE_URL: process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test' ? 'http://' + ip + ':5050' : '',
};
